'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Hubs = require('self-service-api/constants/Hubs');

var _Hubs2 = _interopRequireDefault(_Hubs);

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _ActiveHubSelectors = require('pricing-pages-unified-ui/selectors/ActiveHubSelectors');

var _EditionSelectionButtonGroup = require('../common/EditionSelectionButtonGroup');

var _EditionSelectionButtonGroup2 = _interopRequireDefault(_EditionSelectionButtonGroup);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _Editions = require('self-service-api/constants/Editions');

var _merchUtils = require('self-service-api/core/utilities/merchUtils');

var _ProductOwnershipSelectors = require('pricing-pages-unified-ui/selectors/ProductOwnershipSelectors');

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HubCalcEditionSelectionContainer = function HubCalcEditionSelectionContainer(_ref) {
  var highestOwnedEdition = _ref.highestOwnedEdition,
      activeHub = _ref.activeHub,
      activeCurrencyCode = _ref.activeCurrencyCode,
      activeEdition = _ref.activeEdition,
      setActiveEdition = _ref.setActiveEdition;

  /* don't want to update the active merch to a free active merch because this will reconfigure 
  additionalCostPerUnit and other functions that a free merch id does not support  */
  (0, _react.useEffect)(function () {
    if (highestOwnedEdition !== _Editions.FREE) {
      setActiveEdition(highestOwnedEdition);
    }
  }, [activeHub]);

  var handleEditionUpdated = function handleEditionUpdated(edition) {
    setActiveEdition(edition);

    var merchId = (0, _merchUtils.getHighlightedMerchIdForEdition)(activeHub, edition);
    (0, _getUsageTracker2.default)().track('clickMerchSelectionButton', {
      merchandise: _ImmutableMerchandiseIdMap2.default[merchId].trackingName,
      currency: activeCurrencyCode
    });
  };

  return _react2.default.createElement(_EditionSelectionButtonGroup2.default, {
    activeEdition: activeEdition,
    onEditionUpdated: handleEditionUpdated,
    ownedEdition: highestOwnedEdition
  });
};

HubCalcEditionSelectionContainer.propTypes = {
  activeHub: _react.PropTypes.oneOf(Object.values(_Hubs2.default || {})),
  highestOwnedEdition: _react.PropTypes.string.isRequired,
  activeCurrencyCode: _react.PropTypes.string.isRequired,
  activeEdition: _react.PropTypes.string.isRequired,
  setActiveEdition: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  var activeHub = (0, _ActiveHubSelectors.activeHubSelector)(state);

  return {
    activeHub: activeHub,
    highestOwnedEdition: (0, _ProductOwnershipSelectors.highestOwnedEditionInHubSelector)(state, activeHub),
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(HubCalcEditionSelectionContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/HubCalcEditionSelectionContainer.js
// module id = 737
// module chunks = 3 4